var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_1498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5145 1.13998C2.53246 -2.17404 -0.303557 16.4635 0.0149264 25.6455C3.47275 20.2944 10.1457 12.1158 20.5647 8.49771C20.5647 8.49771 9.29644 15.445 0.909713 30.6165C38.2784 37.2749 31.5145 1.13998 31.5145 1.13998Z",
    fill: "#22AC39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_1498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.6927,
    fill: "white",
    transform: "translate(0 0.744629)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.08a9da864b097bf8fb4bc2ecadb4f57b.svg";
export { ForwardRef as ReactComponent };